import {RefObject, useEffect, useState} from 'react';

/**
 * Becomes (and stays) true once the element comes within `rootMargin` of the viewport — for
 * deferring a card's fetches until it is about to be seen.
 */
export function useNearViewport(ref: RefObject<Element | null>, rootMargin = '300px'): boolean {
    const [isNear, setIsNear] = useState(false);

    useEffect(() => {
        const node = ref.current;
        if (!node || isNear) return;
        const observer = new IntersectionObserver(
            (entries) => {
                if (entries.some((entry) => entry.isIntersecting)) {
                    setIsNear(true);
                }
            },
            {rootMargin},
        );
        observer.observe(node);
        return () => observer.disconnect();
    }, [ref, rootMargin, isNear]);

    return isNear;
}
